import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import Home from './routes/Home';
import Login from './routes/LogIn&SigIn/Login';
import CreateAccount from './routes/LogIn&SigIn/CreateAccount';
import MyAccount from './routes/MyAccount';
import Campain from './routes/Campain';
import SheetCreation from './routes/Campain/Sheet/Create';
import CreateCampain from './routes/MasterView/CreateCampain';
import CampainEdit from './routes/MasterView/CampainEdit';
import Help from './routes/Help';
import CampainPlay from './routes/MasterView/CampainPlay';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/" element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }>
            <Route path="home" element={<Home />} />
            <Route path="myAccount" element={<MyAccount />} />
            <Route path="campain" element={<Campain />} />
            <Route path="campain/sheet/create" element={<SheetCreation />} />
            <Route path="master/campain/create" element={<CreateCampain />} />
            <Route path="master/campain/edit" element={<CampainEdit />} />
            <Route path="master/campain/play" element={<CampainPlay />} />
            <Route path="help" element={<Help />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<CreateAccount />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
